<i18n>
{
  "en": {
    "Optional": "Optional"
  },
  "fr": {
    "Optional": "Optionnel"
  }
}
</i18n>

<template>
  <FormGroup
    :label="label"
    :id="id"
    :localizable="localizable"
    :no-margin="noMargin">
    <div
      :class="{
        'input-group': $slots['input-group-prepend'] ||
          $slots['input-group-append'] ||
          validationPending
    }">
      <slot name="input-group-prepend" />
      <input
        v-validate="validate"
        ref="input"
        :type="type"
        :name="id"
        :id="id"
        :data-vv-as="label ? label.toLowerCase() : ''"
        :value="stringValue"
        :disabled="disabled"
        :placeholder="placeholder"
        class="form-control"
        data-vv-validate-on="input|blur|revalidate"
        v-on="listeners"
      >
      <FormError :id="id" />
      <slot name="input-group-append" />
      <div
        v-if="validationPending"
        class="input-group-append">
        <span class="input-group-text">
          <IconLoading />
        </span>
      </div>
    </div>
  </FormGroup>
</template>

<script>
import getParentFormId from '@/helpers/forms/getParentFormId';
import generateId from '@/helpers/components/generateId';
import FormGroup from './_FormGroup';
import FormError from './_FormError';

export default {
  inject: ['$validator'],
  components: {
    FormGroup,
    FormError,
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    validate: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    localizable: {
      type: Boolean,
      default: false,
    },
    number: {
      type: Boolean,
      default: false,
    },
    noMargin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: '',
      id: generateId(),
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: event => this.updateValue(event),
      };
    },
    isRequired() {
      return this.validate && this.validate.indexOf('required') !== -1;
    },
    placeholder() {
      if (!this.isRequired) {
        return this.$t('Optional');
      }
      return '';
    },
    stringValue() {
      if (this.value !== null) {
        return `${this.value}`;
      }
      return '';
    },
    validationPending() {
      if (this.fields && this.fields[`$${this.form}`] && this.fields[`$${this.form}`][this.id]) {
        return this.fields[`$${this.form}`][this.id].pending;
      }
      return false;
    },
  },
  watch: {
    value(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$refs.input.dispatchEvent(new Event('revalidate', {
            bubbles: true,
            cancelable: true,
          }));
        });
      }
    },
  },
  created() {
    this.form = getParentFormId(this);
  },
  methods: {
    updateValue(event) {
      if (event && event.target) {
        let { value } = event.target;
        if (this.number) {
          let numberValue = 0;

          if (value.indexOf('.') >= 0) {
            numberValue = parseFloat(value);
          } else if (value.indexOf(',') >= 0) {
            value = value.replace(',', '.');
            numberValue = parseFloat(value);
          } else {
            numberValue = parseInt(value, 10);
          }

          if (Number.isNaN(numberValue)) {
            this.$emit('input', value);
          }

          this.$emit('input', numberValue);
        } else {
          this.$emit('input', value);
        }
      }
    },
  },
};
</script>
